import z from 'zod';

/** Status of the question in the review process. */
export enum QuestionStatus {
  /** Freshly generated question */
  GENERATED = 'GENERATED',

  /** Review stages: checked by code (basic checks) */
  CHECKED = 'CHECKED',
  /** Checked by AI */
  VALIDATED = 'VALIDATED',
  /** Reviewed by a user */
  REVIEWED = 'REVIEWED',

  /** Error states: flagged by code */
  FLAGGED = 'FLAGGED',
  /** Out of scope / syllabus flagged by user or reviewer */
  OUT_OF_SCOPE = 'OUT_OF_SCOPE',
  /** Error in question flagged by user or reviewer */
  ERROR = 'ERROR',
}

export const questionStatusSchema = z.enum(QuestionStatus);
